/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Section_FaqInputs */

const en_section_faq = /** @type {(inputs: Section_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const ko_section_faq = /** @type {(inputs: Section_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자주 묻는 질문`)
};

const ja_section_faq = /** @type {(inputs: Section_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくある質問`)
};

/**
* | output |
* | --- |
* | "Frequently Asked Questions" |
*
* @param {Section_FaqInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const section_faq = /** @type {((inputs?: Section_FaqInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Section_FaqInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_section_faq(inputs)
	if (locale === "ko") return ko_section_faq(inputs)
	return ja_section_faq(inputs)
});